import store from '@/store/store';

export default {
  path: 'member-reports',
  name: 'app-member-reports',
  component: () => import('@/views/app/member_reports/MemberReports.vue'),
  meta: {
    pageTitle: 'Member Report'
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'member_reports.header_title';
    const memberReportsResource = await store.state.router.privateRoot.$request().$get('member-reports');
    store.commit('router/updateRouteProp', {
      property: 'memberReportsResource',
      value: memberReportsResource
    });
    next();
  },
  props: () => ({
    memberReportsResource: store.state.router.memberReportsResource
  })
};
